import api from '/src/api.js';

export function getToken (options = {}) {
	return api.post('/socket/token', options);
}
